import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Partners from './pages/Partners';
import FilmserviceHistory from './pages/FilmserviceHistory';
import AlexanderKammelBiography from './pages/AlexanderKammelBiography';
import NominateJury from './pages/NominateJury';
import FilmVideoMagazine from './pages/FilmVideoMagazine';
import OsterreichischesFilmservice from './pages/OsterreichischesFilmservice';
import Imprint from './pages/Imprint';
import { initializeFonts } from './utils/fontLoader';
import { initializeCSSVariables } from './utils/cssVariables';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize CSS variables from configuration
    initializeCSSVariables();
    // Initialize fonts from configuration
    initializeFonts();
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/filmservice-history" element={<FilmserviceHistory />} />
            <Route path="/alexander-kammel-biography" element={<AlexanderKammelBiography />} />
            <Route path="/nominate-jury" element={<NominateJury />} />
            <Route path="/film-video-magazine" element={<FilmVideoMagazine />} />
            <Route path="/osterreichisches-filmservice" element={<OsterreichischesFilmservice />} />
            <Route path="/imprint" element={<Imprint />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
